export default {
  total: '合計 {total} 件',
  page_size: '{size} 件/ページ',
  goTo: 'ページ移動',
  page: 'ページ',
};
